module.exports = __webpack_public_path__ + "img/logo.2364f893.svg";